export const sourceConstant = {
    subtitle:{en:"The answer is sourced from:",
              hi:"जवाब यहाँ से प्राप्त किया गया है:",
              or: "ଉତ୍ତରଟି ଏହିଠାରୁ ନିଆଯାଇଛି:",
              mr: "उत्तर येथून प्राप्त केले आहे:"
            },
    page: {
        en: "Page",
        hi: "पेज",
        or: "ପୃଷ୍ଠା",
        mr: "पृष्ठ"
    },
    and: {
        en: "and",
        hi: "और",
        or: "ଏବଂ",
        mr: "आणि"
    }
}
export const pdfViewerConstant = {
    backToChat: {
        en: "Back to Chat",
        hi: "चैट पर वापस जाएं",
        or: "ଚାଟ ପରେ ଫେରାଇବା",
        mr: "चॅटवर परत जा"
    },
    enterPageNumber: {
        en: "Enter page number",
        hi: "पेज नंबर डालें",
        or: "ପେଜ୍ ନମ୍ବର ଦିଅନ୍ତୁ",
        mr: "पृष्ठ क्रमांक प्रविष्ट करा"
      },
      go: {
        en: "Go",
        hi: "जाएँ",
        or: "ଯାଆନ୍ତୁ",
        mr: "जा"
      },
      cancel: {
        en: "Cancel",
        hi: "कैंसिल",
        or: "କ୍ୟାନସେଲ୍",
        mr: "रद्द करा"
      },
      enterValidPageNumber: {
        en: "Enter Valid page number only",
        hi: "सही पेज नंबर डालें",
        or: "ସଠିକ୍ ପେଜ୍ ନମ୍ବର ଦିଅନ୍ତୁ",
        mr: "कृपया फक्त वैध पृष्ठ क्रमांक प्रविष्ट करा"
      }
      
}